export function parseCoordFromMonitoring(
  value: string | null | undefined
): number | null {
  if (value == null || value === '') return null;
  const n = Number.parseFloat(String(value));
  return Number.isFinite(n) ? n : null;
}
